<template>
  <div id="customer">
    <Header v-if="isReady && userId && !$route.meta.isLander" :custom-feats="customFeats" @error="showError" />
    <div v-if="isReady" id="main" class="wrap">
      <router-view :custom-feats="customFeats" @error="showError" @scroll="scroll" />
    </div>
  </div>
</template>

<script setup>
import { provide, ref, onMounted } from "vue";

import Header from "./components/common/SiteHeader.vue";
import useApi from "./utils/apiCalls.js";
import { isPublicRoute } from "./router/index";

const { apiGetRequest } = useApi();

const userId = ref(null);
const userIsExpert = ref(null);
const userName = ref(null);

// Error
const showError = err => {
  if (!window.navigator.onLine && !err.response) {
    // Offline/aborted - do nothing
  } else {
    // Error handling is now done at the component level
    console.error("Error:", err);
  }
};

// Scroll
const scroll = (selector, delay) => {
  if (delay === void 0) delay = 0;

  if (selector) {
    const element = document.querySelector(selector);
    if (!element) return console.log("Scroll element not found");
    setTimeout(() => {
      element.scrollIntoView({ behavior: "smooth" });
    }, delay);
  } else {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, delay);
  }
};

// User
const isReady = ref(false);
const customFeats = ref({});
const user = () => {
  if (isPublicRoute(window.location.pathname)) {
    isReady.value = true;
    return;
  }

  apiGetRequest({
    path: "/users",
    onSuccess: data => {
      userId.value = data.id;
      userName.value = data.name;
      userIsExpert.value = data.is_expert;

      apiGetRequest({
        path: "/customer-features",
        onSuccess: data => {
          customFeats.value.isReports = data.is_reports;
          customFeats.value.isCustomReports = data.is_custom_reports;
          customFeats.value.isChaperoneReports = data.is_chaperone_reports;
          isReady.value = true;
        },
        onError: () => {
          // Continue even if customer features fail to load
          isReady.value = true;
        },
      });
    },
    onError: err => {
      console.log(err);
      window.location.href = "/login";
      //showError(err);
    },
  });
};

provide("userId", userId);
provide("userIsExpert", userIsExpert);

onMounted(() => {
  user();
});
</script>

<style lang="less">
#customer {
  height: 100%;
  margin: auto;
  min-width: 20rem;
  width: 100%;
}
</style>
